<template>
  <div>
    <v-progress-circular indeterminate color="orange-darken-2" v-show="preLoading" :size="70" :width="4"></v-progress-circular>
    <work-order-category-form
      :workOrderCategory="workOrderCategory"
      :submit="submit"
      :buttonText="t('edit')"
      :loading="loading"
      v-if="!preLoading"
    />
  </div>
</template>

<script setup lang="ts">
import WorkOrderCategoryForm from './Form.vue'
import Say from '@/utils/Say'
import { ref, computed, onBeforeMount } from 'vue';
import { useI18n } from 'vue-i18n';
import store from '@/store';
import { workOrderCategoryStore } from '@/store/workOrderCategories'
import { useRoute } from 'vue-router';
import sayErrorResponse from '@/mixins/sayErrorResponse'

const { t } = useI18n()
const route = useRoute()

const preLoading = ref(true)
const loading = ref(false)

const workOrderCategory = computed(() => workOrderCategoryStore.getters.workOrderCategory)

const setPageTitle = () => {
  store.commit('app.setPageTitle', t('workOrderCategoryEdit') + ' ' + workOrderCategory.value.name)
  store.commit('app.setBreadcrumbs', [
    { text: t('workOrderCategory', 2), routeName: 'WorkOrderCategoriesList' },
    { text: t('workOrderCategoryEdit') + ' ' + workOrderCategory.value.name }
  ])
}

onBeforeMount(() => {
  workOrderCategoryStore.dispatch('fetchWorkOrderCategory', route.params.id)
    .then(() => {
      setPageTitle()
      preLoading.value = false
    })
    .catch((err: any) => {
      sayErrorResponse(err)
    })
})

const submit = () => {
  loading.value = true

  workOrderCategoryStore.dispatch('updateWorkOrderCategory', {
    id: workOrderCategory.value.id,
    data: { color: workOrderCategory.value.color }
  }).then(() => {
    loading.value = false
    Say('success', t('workOrderCategoryEditSuccess'))
  }).catch((err: any) => {
    loading.value = false
    sayErrorResponse(err)
  })
}
</script>
